import Element from 'element-ui'
import ImgPopover from '@/components/img-popover'
import Tips from '@/components/tips'
import TagCloseable from '@/components/TagCloseable'
import KeywordsTag from '@/components/KeywordsTag'

import AdTypeTag from '@/components/AdTypeTag'
import StateDot from '@/components/StateDot'
import StateDotTooltip from '@/components/StateDotTooltip'

import TabsNew from '@/components/TabsNew'
import TipsButton from '@/components/tips-button'
import TipsStr from '@/components/tips-str'
import CardTable from '@/components/config-tables/card-table'
import ConfigForm from '@/components/config-form'
import PageBtn from '@/components/config-tables/page-btn'
import HCPageBtnSimple from '@/components/HCPageBtnSimple'
import IconHc from '@/components/IconHc/index.vue'
import AmountShow from '@/components/AmountShow/index.vue'
import CountryImg from '@/components/CountryImg/index.vue'
import CurrencyTypeInput from '@/components/CurrencyTypeInput/index.vue'
import AmountInput from '@/components/AmountInput/index.vue'
import HcListPop from '@/components/HcListPop/index.vue'
import HcRouterLink from '@/components/HcRouterLink.vue'
import HcButton from '@/components/HcButton.vue'
import HcAutoTooltip from '@/components/HcAutoTooltip/index.vue'
import TextCarousel from '@/components/TextCarousel.vue'
import HcNoData from '@/components/HcNoData'
import HcEditAmountPop from '@/components/HcEditAmountPop.vue'
import HcImage from '@/components/HcImage'
import HcTextParagraph from '@/components/HcTextParagraph'
import DialogWrap from '@/components/dialog-wrap/index.vue'
import HcDropdown from '@/components/HcDropdown'
import HcDropdownMenu from '@/components/HcDropdown/HcDropdownMenu.vue'
import HcDropdownItem from '@/components/HcDropdown/HcDropdownItem.vue'
import HcTextEditorPopover from '@/components/HcTextEditorPopover.vue'

import quePngUrl from '@/../static/images/que.png'
import fileBg from '@/../static/images/file-bg.png'

import { resolveVueRouterAndOpenNewTab } from '@/services/utils/modules/routerWrapper'

import Copy from '@/components/Copy/index.vue'
import 'xe-utils'
import {
  VXETable,
  Header,
  Footer,
  Column,
  Table,
  Grid,
  Tooltip,
  Icon,
  Colgroup,
  Switch
} from 'vxe-table'

import i18n from '@/i18n'

VXETable.setup({
  zIndex: 10000,
  table: {
    size: 'small',
    emptyText: '暂无数据',
    align: 'left',
    autoResize: true,
    syncResize: true,
    resizable: true,
    showOverflow: true,
    showHeaderOverflow: true,
    highlightHoverRow: true,
    sortConfig: {
      trigger: 'cell',
      orders: ['desc', 'asc', null]
    },
    checkboxConfig: {
      highlight: true,
    },
    resizableConfig: {
      minWidth: 10,
    },
    scrollX: {
      mode: 'wheel',
      gt: 20,
      oSize: 5,
    },
    scrollY: {
      mode: 'wheel',
      gt: 50,
      oSize: 5,
    },
  },
  grid: {
    size: 'small'
  },
  icon: {
    TABLE_TREE_OPEN: 'iconhuice icon-jianhaoshouqi',
    TABLE_TREE_CLOSE: 'iconhuice icon-jiahaozhankai'
  },
  i18n: (key, args) => i18n.t(key, args)
})

VXETable.renderer.add('NotData', {
  // 空内容模板
  renderEmpty(h, renderOpts) {
    return [
      <div class="mt16 mb16">
        <img width="194" src={quePngUrl} />
        <div style="color: #919499">暂无数据</div>
      </div>
    ]
  }
})
VXETable.renderer.add('NotData-big', {
  // 空内容模板
  renderEmpty(h, renderOpts) {
    return [
      <span>
        <img width="240" height="165" src={quePngUrl} />
        <div style="color: #919499">暂无数据</div>
      </span>
    ]
  }
})
VXETable.renderer.add('NotData-init', {
  // 空内容模板
  renderEmpty(h, renderOpts) {
    return [
      <div style="margin-top: -50px">
        <div style="width: 60px; height: 60px; margin: 0 auto; position: relative;">
          <img width="60" height="60" src={fileBg} />
          <div style="position: absolute; width: 20px; height: 20px; bottom: 5px; right: 2px">
            <i style="color: #FFF; font-size: 14px" class="el-icon-loading"></i>
          </div>
        </div>
        <div style="line-height: 18px; margin-top: 15px"><span style="color: #313233; font-size: 13px;">先进先出正在初始化中...</span></div>
        <div style="color: #919499; margin-top: 4px">注：大概需要1-2H的时间，系统会提供需要录入初始成本的MSKU，请稍后在本页面下载需录入的初始化成本</div>
      </div>
    ]
  }
})
VXETable.renderer.add('NotData-notInit', {
  // 空内容模板
  renderEmpty(h, renderOpts) {
    return [
      <div style="margin-top: -50px">
        <img width="240" height="165" src={quePngUrl} />
        <div style="line-height: 18px; margin-top: 16px"><span style="color: #313233; font-size: 13px; font-weight: 400">当前未设置批次成本</span></div>
        <div style="color: #919499; margin-top: 4px; line-height: 18px;">批次成本设置方式：设置<span> &gt; </span>财务设置<span> &gt; </span>成本<span> &gt; </span>批次成本<span> &gt; </span>去初始化</div>
        <el-button type="primary" style="margin-top: 16px" onClick={() => { resolveVueRouterAndOpenNewTab({ name: 'bi-settingsFinanceSettings' }) }}>去设置</el-button>
      </div>
    ]
  }
})

export default {
  install(Vue) {
    Vue.use(Element, {
      size: 'small' // set element-ui default size
    })
    Vue.use(VXETable)
    Vue.use(Header)
    Vue.use(Footer)
    Vue.use(Column)
    Vue.use(Table)
    Vue.use(Grid)
    Vue.use(Tooltip)
    Vue.use(Icon)
    Vue.use(Colgroup)
    Vue.use(Switch)
    Vue.component('ImgPopover', ImgPopover)
    Vue.component('Tips', Tips)

    Vue.component('AdTypeTag', AdTypeTag)
    Vue.component('StateDot', StateDot)
    Vue.component('StateDotTooltip', StateDotTooltip)

    Vue.component('TagCloseable', TagCloseable)
    Vue.component('KeywordsTag', KeywordsTag)

    Vue.component('TabsNew', TabsNew)
    Vue.component('TipsButton', TipsButton)
    Vue.component('TipsStr', TipsStr)
    Vue.component('CardTable', CardTable)
    Vue.component('ConfigForm', ConfigForm)
    Vue.component('PageBtn', PageBtn)
    Vue.component('HCPageBtnSimple', HCPageBtnSimple)
    Vue.component('IconHc', IconHc)
    Vue.component('AmountShow', AmountShow)
    Vue.component('CountryImg', CountryImg)
    Vue.component('Copy', Copy)
    Vue.component('CurrencyTypeInput', CurrencyTypeInput)
    Vue.component('AmountInput', AmountInput)
    Vue.component('HcListPop', HcListPop)
    Vue.component('HcRouterLink', HcRouterLink)
    Vue.component('HcButton', HcButton)
    Vue.component('HcAutoTooltip', HcAutoTooltip)
    Vue.component('TextCarousel', TextCarousel)
    Vue.component('HcNoData', HcNoData)
    Vue.component('HcEditAmountPop', HcEditAmountPop)
    Vue.component('HcImage', HcImage)
    Vue.component('HcTextParagraph', HcTextParagraph)
    Vue.component('DialogWrap', DialogWrap)
    Vue.component('HcDropdown', HcDropdown)
    Vue.component('HcDropdownMenu', HcDropdownMenu)
    Vue.component('HcDropdownItem', HcDropdownItem)
    Vue.component('HcTextEditorPopover', HcTextEditorPopover)
  }
}
